export const CONSTANTS = {
  SECTIONS: {
    ABOUT: { id: "about" },
    CONTACT: { id: "contacts" },
    HOME: { id: "home" },
    PROJECT: { id: "projects" },
    EXPERIENCE: { id: "experience" },
    SKILLS: { id: "skills" },
    GALLERY: { id: "gallery" },
  },
};
